@if (hasDuplicates()) {
  <xcs-patient-duplicates-banner
    [duplicates]="duplicates()"
    [hasTabs]="hasTabs()"
    [initialOpen]="duplicates().length < 5"
    (selectEdit)="editPatient($event)">
  </xcs-patient-duplicates-banner>
}
@if (saveError()) {
  <xui-alert type="danger" [message]="saveError()" [dismissible]="true" (dismissed)="dismissError()" [class.has-tabs]="hasTabs()"></xui-alert>
}
<mat-card appearance="outlined" class="mb-3" [class.valid]="formValid() && validate()" [class.invalid]="!formValid() && validate()">
  <mat-card-content>
    @if (validate() && !formValid()) {
      <p class="card-text mat-text-warn" (click)="toggleFullErrorMessage()">Please correct any errors highlighted in red on the form.</p>
    }
    @if (showFullErrorMessage()) {
      <ul class="full-error-message">
        @for (error of fullFormError(); track $index) {
          <li class="card-text mat-text-warn">{{error.key}}: {{error.control.errors | json}}</li>
        }
      </ul>
    }
    @if (form) {
      <form class="form" [formGroup]="form" [class.form-validated]="validate()">
      @if (isEditForm) {
        <input type="hidden" [formControlName]="'status'">
      }
        <div class="row">

          <div class="col-sm-12">
            <div class="d-flex flex-row align-items-center justify-content-between">
              <h2 class="mb-3">Name</h2>
              @if (!isEditForm) {
                <button mat-stroked-button color="warn"  (confirm)="clearSavedFormData()" xuiConfirmationDialog [confirmMessage]="'Are you sure you wish to clear all form data? This will reset the form and remove any saved data.'">
                  Clear Form
                </button>
              }
            </div>
          </div>
        </div>
    <div class="row mb-3">
      <div class="col-sm-12 col-md-6">
        <mat-form-field appearance="fill" color="primary" class="w-100">
          <mat-label>Select Title</mat-label>
          <mat-select formControlName="title">
            @for (title of titles(); track title.value) {
              <mat-option [value]="title.value">{{title.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" color="primary" class="w-100">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstName" type="text"/>
        </mat-form-field>
        <mat-form-field appearance="fill" color="primary" class="w-100">
          <mat-label>Surname</mat-label>
          <input matInput formControlName="surname" type="text"/>
        </mat-form-field>
        <mat-form-field appearance="fill" color="primary" class="w-100">
          <mat-label>Middle Name(s)</mat-label>
          <input matInput formControlName="middleNames" type="text"/>
        </mat-form-field>
        <mat-form-field appearance="fill" color="primary" class="w-100">
          <mat-label>Nickname</mat-label>
          <input matInput formControlName="nickname" type="text"/>
        </mat-form-field>
      </div>
      @if (isEditForm && editRail()) {
        <div class="col-sm-12 col-md-6">
          <ng-container *ngTemplateOutlet="editRail()!"/>
        </div>
      }
    </div>
    <mat-divider inset></mat-divider>
    <div class="row mb-3">
      <div class="col-12">
        <h2 class="mb-3">Identification</h2>
        <div class="row">
          <div class="col-12 col-md-6">
            @if (useFileNumberAsPatientProfileId()) {
              <mat-form-field appearance="fill" color="primary" class="w-100">
                <mat-label>Existing File Number</mat-label>
                <input matInput formControlName="fileNumber" type="text"/>
              </mat-form-field>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Identity Number</mat-label>
              <input matInput formControlName="identityNumber" type="text"/>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Confirm Identity Number</mat-label>
              <input matInput formControlName="identityNumberConfirmation" type="text"/>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Date Of Birth</mat-label>
              <input matInput [min]="minDobValue" [max]="maxDobValue" [matDatepicker]="picker" formControlName="dateOfBirth" />
              <mat-datepicker  #picker></mat-datepicker>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Passport Number</mat-label>
              <input matInput formControlName="passportNumber" type="text"/>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Confirm Passport Number</mat-label>
              <input matInput formControlName="passportNumberConfirmation" type="text"/>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <mat-divider inset></mat-divider>
    <div class="row mb-3">
      <div class="col-12">
        <h2 class="mb-3">Demographics</h2>
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Select Gender</mat-label>
              <mat-select formControlName="gender">
                @for (option of genders(); track option.value) {
                  <mat-option [value]="option.value">{{option.text}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Select Language</mat-label>
              <mat-select formControlName="homeLanguage">
                @for (option of languages(); track option.value) {
                  <mat-option [value]="option.value">{{option.text}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="fill" color="primary" class="w-100">
              <mat-label>Select Race</mat-label>
              <mat-select formControlName="race">
                @for (option of races(); track option.value) {
                  <mat-option [value]="option.value">{{option.text}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <mat-divider inset></mat-divider>
    <xcs-patient-contact-methods-fieldset
      [contactNumbers]="contactNumbers"
      [emailAddresses]="emailAddresses"
      [addressDetails]="addressDetails"
      [secondaryContacts]="secondaryContacts"
      [validate]="validate()">
    </xcs-patient-contact-methods-fieldset>
    <p class="text-center w-50" [class.mat-text-warn]="validate() && hasContactMethodError()">At least one contact method is required</p>
    <mat-divider inset></mat-divider>
    <div class="row mb-3">
      <div class="col-sm-12 col-md-6">
        <xcs-patient-doctors-fieldset
          [array]="familyDoctors"
          kind="family"
          heading="Family Doctor's Details"
          emptyMessage="No family doctors have been added to this patient."
          [doctorSearch]="doctorSearch()"
          [doctorAddPersist]="doctorAddPersist()"
          [doctorEditPersist]="doctorEditPersist()">
        </xcs-patient-doctors-fieldset>
      </div>
      <div class="col-sm-12 col-md-6">
        <xcs-patient-doctors-fieldset
          [array]="referringDoctors"
          kind="referring"
          heading="Referring Doctor's Details"
          emptyMessage="No referring doctors have been added to this patient."
          [doctorSearch]="doctorSearch()"
          [doctorAddPersist]="doctorAddPersist()"
          [doctorEditPersist]="doctorEditPersist()">
        </xcs-patient-doctors-fieldset>
      </div>
    </div>
    <mat-divider inset></mat-divider>
    <xcs-patient-billing-contact-fieldset
      [group]="billingContact"
      (sameAsPatient)="setBillingDetailsToPatientDetails()">
    </xcs-patient-billing-contact-fieldset>
    <p class="text-center w-50" [class.mat-text-warn]="validate() && hasBillingContactMethodError()">At least one billing contact method is required</p>
    <mat-divider inset></mat-divider>
    <xcs-patient-medical-aid-fieldset [group]="medicalAid" [medicalSchemeSearch]="medicalSchemeSearch()"></xcs-patient-medical-aid-fieldset>
    @if (!useFileNumberAsPatientProfileId()) {
      <mat-divider inset></mat-divider>
      <div class="row">
        <div class="col-12 col-md-6">
          <h2>Bookkeeping</h2>
          <mat-form-field appearance="fill" color="primary" class="w-100">
            <mat-label>Existing File Number</mat-label>
            <input matInput formControlName="fileNumber" type="text"/>
          </mat-form-field>
        </div>
      </div>
    }
    @if (validate() && !formValid()) {
      <p class="card-text mat-text-warn" (click)="toggleFullErrorMessage()">Please correct any errors highlighted in red on the form.</p>
    }
    @if (showFullErrorMessage()) {
      <ul class="full-error-message">
        @for (error of fullFormError(); track $index) {
          <li class="card-text mat-text-warn">{{error.key}}: {{error.control.errors | json}}</li>
        }
      </ul>
    }
    </form>
  }
  </mat-card-content>
  <mat-card-actions>
    <button type="button" mat-flat-button (click)="cancel()">Cancel</button>
    @if (canWrite()) {
      @if (!isEditForm) {
        <button mat-flat-button color="primary" (confirm)="submit()" xuiConfirmationDialog [confirmMessage]="'Are you sure you wish to add this patient to the system?'">
          Create Patient
        </button>
      } @else {
        <button mat-flat-button color="primary" (confirm)="submit()" xuiConfirmationDialog [confirmMessage]="'Are you sure you wish to update this patient?'">
          Save Changes
        </button>
      }
    }
  </mat-card-actions>
</mat-card>
